module.exports = __webpack_public_path__ + "static/rpm_estandard-e268219c953e8882470bed1d8d54712a.png";